
import { useLocation } from 'react-router';
import React from 'react';

export function useQuery(queryString) {
  const { search } = useLocation();
  const searchString =  !!queryString ? queryString : search;
  return React.useMemo(() => new URLSearchParams(searchString), [ searchString ]);
}

export function useHash() {
  const { hash } = useLocation();
  return hash;
}
